import { ServiceFetch } from '../service-fetch'

export default class ReceiptDiscountListModel extends ServiceFetch {
    getReceiptDiscountListBy = (data) => this.authFetch({
        url: 'receipt-discount-list/getReceiptDiscountListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}